import React from 'react'
import { useTranslation } from 'react-i18next'

import Toggle from 'components/Form/Toggle/Toggle'

import styles from './RewardBlock.module.scss'

const RewardBlock = ({ isRewardable, onUpdate }) => {
    const { t } = useTranslation()

    return (
        <div className={styles.rewardBlock}>
            <div className={styles.main}>
                <Toggle
                    value={isRewardable}
                    onUpdate={v => onUpdate(v)}
                    label={t('Enable reward giveaway')}
                    sliderWrapperClassName={styles.toggleWrapper}
                    sliderLabelClassName={styles.toggleLabel}
                />
            </div>
            <div className={styles.text}>
                {t(
                    "When enabled, the wheel selects from the reward list you've configured, including coupons, promo codes, or physical prizes.",
                )}
            </div>
        </div>
    )
}

export default RewardBlock
